module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-id-ID.048cd3a0.jpg";